import { cn } from 'lib/util/cn'

/**
 * @deprecated this has been migrated to the web app and any changes should be made in both the web app and here
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('tw-bg-muted tw-animate-pulse tw-rounded-md', className)} {...props} />
}

export { Skeleton }
